import { useAuth0 } from "@auth0/auth0-react";
import { MouseEvent, useEffect } from "react";
import { Button } from "react-bootstrap";
import { useNavigate } from "react-router";
import FooterComponent from "../footer/FooterComponent";
import "./landingComponent.scss";

const LandingComponent = (props) => {
  const navigate = useNavigate();

  const { isAuthenticated } = useAuth0();

  const btnLoginUserHandler = async (event: MouseEvent) => {
    navigate("/user/profile");
  };

  useEffect(() => {
    if (isAuthenticated) {
      navigate("/user/profile");
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAuthenticated]);

  return (
    <>
      {!isAuthenticated && (
        <main>
          <div className="main-content-container w-100">
            <div className="grid-container">
              <div className="row w-100 h-100 align-items-center">
                <div className="col-lg-3 d-none d-md-block">{/* empty */}</div>
                <div className="col-lg-9">
                  <div className="login-container">
                    <div className="logoContainer">
                      <a href="https://www.mim.ac">
                        <img
                          src={process.env.PUBLIC_URL + "/images/mim-logo.png"}
                          className="logo-login mt-60 h-[68px]"
                          alt="mim logo"
                        />
                      </a>
                    </div>
                    <div className="loginButtonContainer ">
                      <Button
                        variant="primary-3"
                        onClick={btnLoginUserHandler}
                        className="w-[400px]"
                      >
                        Login
                      </Button>
                    </div>
                    <div className="registerAccountContainer">
                      <p>
                        Don't have an account?{" "}
                        <span className="text-underline">
                          <a href="/user/register">Register Here</a>
                        </span>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <FooterComponent />
        </main>
      )}
    </>
  );
};

export default LandingComponent;
